import React from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import ManageCollectionCategories from '../../components/collection/manage-collection-categories';

const ContentCollectionsManageCategories = () => {
  const { id } = useParams();
  const pageTitle = 'Content / Collection';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ManageCollectionCategories id={id} />
    </AppLayout>
  );
};

export default ContentCollectionsManageCategories;
